import * as d3 from 'd3';
import { dN_Circle_Oculus } from './d_circle_oculus';
import { drawHinge } from './drawHinge';
import { drawGrillsOculus } from './GrillsOculus/drawGrillsOculus';
import { getGlassDesign } from './glassPatternsDefs';

/* outerShape available values:
   Rect,
   Half Round,
   Extended Half Round,
   Ellipse,
   Trapezoid,
   Eyebrow,
   Extended Eyebrow,
   Half Eyebrow,
   Extended Half Eyebrow,
   Cathedral,
   Extended Cathedral
*/
export function drawOculus(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false,
    outerShape = 'Rect', radiusX = null, radiusY = null, circleWidth = frameWidth )
{
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
    const finishColor = doorData.flipped ? doorData?.finish?.exteriorColor?.value || 'white' :
                                           doorData?.finish?.interiorColor?.value || 'white' ;


    // Access type dynamically
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;

    if (frameData?.[typeKey] === 'Oculus') {
        let windowWidth = parseFloat(frameData[widthKey]);
        //const windowHeight = parseFloat(frameData.windowHeight_d); // - 2*d;

        let adjustedWidth = (windowWidth - frameWidth * 2) / 2;

        let xOffset = initX ;
        for (let i = 1; i < indexWindow; i++) {
            const key = `windowWidth${i}_d`;
            xOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d ;
        }


        const glassType = `glassType${indexWindow}`;
        const glassColor = doorData?.glass?.[glassType].value || 'white';
        if (OneSection){
            xOffset = initX;
            windowWidth = parseFloat(frameData?.uWidth1_d)  -
            2 * frameWidth - 2*d + parseInt(nSections);
            adjustedWidth = (windowWidth - 2 * frameWidth)*0.5;
        }
        const glassDesign = getGlassDesign(doorData);

        // Calculate default radiusX and radiusY if not provided
        // The outer ellipse should not touch the rectangle frame, so we subtract frameWidth
        let calculatedRadiusX = radiusX !== null ? radiusX : (windowWidth / 2) - circleWidth - frameWidth;
        let calculatedRadiusY = radiusY !== null ? radiusY : (windowHeight / 2) - circleWidth - frameWidth;

        // Use frameData radius values if available
        /*if (top) {
            const radiusXKey = `radiusxTop${indexWindow}_d`;
            const radiusYKey = `radiusyTop${indexWindow}_d`;
            if (frameData?.[radiusXKey]) calculatedRadiusX = parseFloat(frameData[radiusXKey]);
            if (frameData?.[radiusYKey]) calculatedRadiusY = parseFloat(frameData[radiusYKey]);
        } else {
            const radiusXKey = `radiusx${indexWindow}_d`;
            const radiusYKey = `radiusy${indexWindow}_d`;
            if (frameData?.[radiusXKey]) calculatedRadiusX = parseFloat(frameData[radiusXKey]);
            if (frameData?.[radiusYKey]) calculatedRadiusY = parseFloat(frameData[radiusYKey]);
        }*/

        // Oculus is ALWAYS a circle/oval, regardless of the outer container shape
        dN_Circle_Oculus(svg, d, xOffset, initY, [
            {
                w: windowWidth,
                h: windowHeight - 1,
                radiusX: calculatedRadiusX,
                radiusY: calculatedRadiusY,
                circleWidth: circleWidth,
                color: glassColor || 'lightblue',
                glassType: doorData?.glass?.glassType1.label,
                glassDesign: glassDesign,
                frameWidth,
                frameColor: finishColor,
                lineFrameColor: 'black',
                lineFrameThickness: 1,
                outerStrokeColor: 'black',
                outerStrokeWidth: 1
            }
        ], `\u00A0${indexWindow} ✔`, true, {
            fontSize: 24,
            fontColor: 'green',
            fontOpacity: 0.2
        }, outerShape);


        drawGrillsOculus(svg, indexWindow,
                   xOffset , initY,
                   windowWidth, /*2*adjustedWidth + 2*frameWidth,*/
                   windowHeight,
                   frameWidth,
                   doorData, top, calculatedRadiusX, calculatedRadiusY, outerShape);
    }
}//drawOculus
